import { render, staticRenderFns } from "./ShiftAssign.vue?vue&type=template&id=6761559c"
import script from "../../controllers/shift/shift-assign.js?vue&type=script&lang=js&external"
export * from "../../controllers/shift/shift-assign.js?vue&type=script&lang=js&external"
import style0 from "./ShiftAssign.vue?vue&type=style&index=0&id=6761559c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports